var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "site-profile-users" }, [
    _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(_vm._s(_vm.$t("settings.siteUser")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("status.name")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("lastLogin")))]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _c("tr", { staticClass: "site-profile-users-table-filters" }, [
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterUser,
                  expression: "filterUser",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.filterUser },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filterUser = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "td",
            { staticClass: "settings-filter" },
            [
              _c("HKLSelect", {
                staticClass: "align-center",
                attrs: {
                  value: _vm.filterStatus,
                  "settings-filter-row": "",
                  options: _vm.userStatusHklOptions,
                  showSearch: false,
                  placeholder: "",
                },
                on: {
                  change: function (val) {
                    _vm.filterStatus = val
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("td"),
        ]),
        _vm._v(" "),
        _vm._l(_vm.orderedUsers, function (item, index) {
          return _c("tr", { key: index }, [
            _c("td", [
              _c("span", [_vm._v(_vm._s(_vm.userName(item)))]),
              _vm._v(" "),
              !item.enabled
                ? _c("i", {
                    staticClass: "fa fa-ban",
                    attrs: { "aria-hidden": "true" },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", [_c("span", [_vm._v(_vm._s(_vm.showStatus(item)))])]),
            _vm._v(" "),
            _c("td", [
              _c("span", [_vm._v(_vm._s(_vm.formatDate(item.lastLoginAt)))]),
            ]),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }